import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'esa-ui-library';
import { useStore } from '../../../../../common';

interface BulkSelectProps {
	id: string;
	disabled?: boolean;
}

const BulkSelect: FC<BulkSelectProps> = ({ id, disabled }): JSX.Element => {
	const [{ bulkRows }, dispatch] = useStore();

	const onBulkChange = () => {
		dispatch('BULK_CHANGE', id);
	};

	return <Checkbox checked={bulkRows.includes(id)} disabled={disabled} onChange={onBulkChange} dataId='bulk-select' />;
};

BulkSelect.propTypes = {
	id: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
};

export { BulkSelect };
